import React, { useEffect, useState } from 'react';
import { useParams, useLocation } from 'react-router-dom';
import axios from 'axios';
import { Card, Typography, Spin, Tag, Descriptions, message } from 'antd';
import { API_BASE_URL } from '../../utils/BaseUrl';

const { Title } = Typography;

const GymStatus = () => {
  // const { gymId } = useParams();
  const [gym, setGym] = useState(null);
  const [loading, setLoading] = useState(true);

   const location = useLocation();
  const searchParams = new URLSearchParams(location.search);
  const gymId = searchParams.get('gymId'); 

  const user = JSON.parse(localStorage.getItem('user')).userId;

  useEffect(() => {
    console.log("gymId từ URL:", gymId);
    const fetchGym = async () => {
      try {
        const res = await axios.get(`${API_BASE_URL}/api/Gym/owner?ownerId=${user}`);
        setGym(res.data);
      } catch (err) {
        message.error('Không thể lấy thông tin phòng gym');
      } finally {
        setLoading(false);
      }
    };

    fetchGym();
  }, [gymId]);

  if (loading) return <Spin style={{ display: 'block', margin: '100px auto' }} />;

  return (
    <Card style={{ maxWidth: 800, margin: '40px auto', borderRadius: 12 }}>
      <Title level={3} style={{ color: '#1890FF' }}>Trạng thái phê duyệt phòng gym</Title>
      <Descriptions bordered column={1}>
        <Descriptions.Item label="Tên phòng gym">{gym?.name}</Descriptions.Item>
        <Descriptions.Item label="Địa chỉ">{gym?.address}</Descriptions.Item>
        <Descriptions.Item label="Giờ mở cửa">{gym?.openingHours}</Descriptions.Item>
        <Descriptions.Item label="Trạng thái">
          <Tag color={gym?.status === 'Approved' ? 'green' : 'orange'}>
            {gym?.status}
          </Tag>
        </Descriptions.Item>
        <Descriptions.Item label="Ngày tạo">{new Date(gym?.createdAt).toLocaleString()}</Descriptions.Item>
      </Descriptions>
    </Card>
  );
};

export default GymStatus;
